import { htmlParser } from "../../../../";

var MobileCampusActivityTabDetails = function MobileCampusActivityTabDetails(props) {
  // console.log("MobileCampusActivityTabDetails", props);
  return props.data ? htmlParser(props.data) : null;
};

export { MobileCampusActivityTabDetails };